export default __webpack_public_path__ + "static/media/Contact_us.843edb6b.svg";